/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface SaveDealAsIgnore200ResponseJournalEntriesInner
 */
export interface SaveDealAsIgnore200ResponseJournalEntriesInner {
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'amount': number | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'freeeAccountItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'freeeTaxCode': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'isInvalidTaxCode': boolean;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'invalidTaxCodeCause': SaveDealAsIgnore200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'freeeMemoTags': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'freeeSectionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'freeeItemId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'segment1TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'segment2TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'segment3TagId': string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveDealAsIgnore200ResponseJournalEntriesInner
     */
    'description': string | null;
}

export const SaveDealAsIgnore200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = {
    qualifiedButPartDeduct: 'QUALIFIED_BUT_PART_DEDUCT',
    notQualifiedButFullDeduct: 'NOT_QUALIFIED_BUT_FULL_DEDUCT',
    preStartButPartDeduct: 'PRE_START_BUT_PART_DEDUCT',
    inconsistentDeductRate: 'INCONSISTENT_DEDUCT_RATE'
} as const;

export type SaveDealAsIgnore200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum = typeof SaveDealAsIgnore200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum[keyof typeof SaveDealAsIgnore200ResponseJournalEntriesInnerInvalidTaxCodeCauseEnum];


